<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>材料管理</el-breadcrumb-item>
      <el-breadcrumb-item>出库单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="仓库" prop="stockroom_id" v-if="!admin">
            <stockroom-select
              :clearable="false"
              :val="filter.stockroom_id"
              @change="filter.stockroom_id = $event"
            ></stockroom-select>
          </el-form-item>
          <el-form-item label="单号">
            <el-input
              size="small"
              v-model="filter.number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="filter.status">
              <el-option
                v-for="(value, index) in OutboundOrderStatusMap"
                :key="index"
                :label="value"
                :value="parseInt(index)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出库日期" prop="date">
            <el-date-picker
              clearable
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData(false)
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel">
      <!-- <file-button
        obj="purchase_order"
        :importButton="false"
        :filter="filter"
        style="float: right"
        v-code="61101"
      ></file-button> -->
      <mytable :list="list"></mytable>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import mytable from './table.vue'
import { outboundOrderList } from '@/service/getData'
import { OutboundOrderStatusMap } from '@/config/global'
import { getStore } from '@/config/mUtils'
import StockroomSelect from '@/components/select/stockroom_select'

export default {
  components: {
    mytable,
    StockroomSelect,
  },
  data() {
    return {
      admin: getStore('userInfo').is_stockroom_admin,
      OutboundOrderStatusMap,
      filter: {
        // category: this.category,
        stockroom_id: 1,
        page: 1,
        size: 10,
        status: '',
        number: '',
        date: '',
      },
      total: 0,
      list: [],
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.stockroom_id = 1
        this.filter.status = ''
        this.filter.number = ''
        this.filter.date = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1

      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      let res = await outboundOrderList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.count
      }
    },
  },
}
</script>